import isRegulationVersionValid from './isRegulationVersionValid'

const regulations = {
  isRegulationVersionValid,
}

export default regulations
